export const SET_THEME_MODE = 'SET_THEME_MODE';

const setAction = (type, payload) => ({
    type,
    payload,
});

export const setThemeMode = ( mode ) => (dispatch)=>{
    dispatch(setAction(SET_THEME_MODE, mode || 'light' ));
}